let _isDemoMode = false;

export function isDemoMode(): boolean {
  return _isDemoMode;
}

export function setDemoMode(value: boolean): void {
  _isDemoMode = value;
}
